/*
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
 */
import { favoritesApi } from "../AlfrescoApi.js";
import { nodeToMenuItem } from "./NodeToMenuItemService.js";
import { useUserStore } from "@/stores/user.js";
import { useMenuStore } from "@/stores/menu.js";
import { useFavoritesStore } from "@/stores/favorites.js";

import { newPristyError } from "./ErrorService.js";

/**
 * Service class that provides methods to interact with a user's list of favorite items.
 */
class FavoriteService {
  getFavorites(filter) {
    const favoritesStore = useFavoritesStore();
    return favoritesStore.loadFavorites().then((favorites) => {
      if (filter) {
        return favorites.filter((fav) => fav.target && fav.target[filter]);
      }
      return favorites;
    });
  }

  changeSingleFavorite(item) {
    if (item.isFavorite) {
      return this.deleteFavoris(item);
    } else {
      return this.createFavorite(item);
    }
  }

  createFavorite(item) {
    const user = useUserStore();
    const menuStore = useMenuStore();

    let favoriteBodyCreate = { target: {} };
    let guid = { guid: item.id };
    if (item.nodeType === "st:site") {
      favoriteBodyCreate.target = { site: guid };
    } else if (item.isFile) {
      favoriteBodyCreate.target = { file: guid };
    } else {
      favoriteBodyCreate.target = { folder: guid };
    }

    return favoritesApi
      .createFavorite(user.person.id, favoriteBodyCreate)
      .then((favorite) => {
        item.isFavorite = favorite.entry.targetGuid === item.id;
        useFavoritesStore().addFavoriteToCache(favorite.entry);
        return item;
      })
      .then((item) => {
        if (item.isFavorite) {
          menuStore.addFavorite(nodeToMenuItem(item), "menuFavoris");
        }

        return item;
      })
      .catch((err) => {
        throw newPristyError("createFavorite", err);
      });
  }

  deleteFavoris(item) {
    const user = useUserStore();
    const menuStore = useMenuStore();
    return favoritesApi
      .deleteFavorite(user.person.id, item.id)
      .then(() => {
        item.isFavorite = false;
        useFavoritesStore().removeFavoriteFromCache(item.id);
        return item;
      })
      .then((item) => {
        if (!item.isFavorite) {
          menuStore.removeFavorite(nodeToMenuItem(item), "menuFavoris");
        }

        return item;
      })
      .catch((err) => {
        console.error(err);
        throw newPristyError("getSharedLink", err);
      });
  }
}

export default new FavoriteService();
